export function dynamicDigitsMask(length: number): string {
  if (!length) {
    return '';
  }

  return '0'.repeat(length);
}
